import { render, staticRenderFns } from "./keyover.vue?vue&type=template&id=6dec259d&"
import script from "./keyover.vue?vue&type=script&lang=js&"
export * from "./keyover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports